import React from 'react'
import PropTypes from 'prop-types'

const ArrowRightIcon = ({ className, title }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    aria-label={title}
  >
    <path
      d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

ArrowRightIcon.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string
}

ArrowRightIcon.defaultProps = {
  className: '',
  title: ''
}

export default ArrowRightIcon
